import React, { Component } from "react";

class SliderWithVideo extends Component {
  render() {
    return (
        <div className="slider-activation color-white">
            {/* Start Single Slide */}
            <div className="slide slide-style-1 slider-fixed--height d-flex align-items-center bg_image bg_image--1" data-black-overlay="6">
                <div className="container position-relative">
                    <div className="row">
                        <div className="col-lg-12 mb-5"> 
                        {/* <div className="col-lg-7">  */}
                            <div className="inner">
                                <h1 className="title color-white">HIS PRESENCE</h1>
                                {/* <h1 className="title color-white">A digital <br /> agency. </h1> */}
                                <p className="description">Our mission is to create a sanctuary where the tangible Presence of God is experienced.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            {/* End Single Slide */}
        </div>
    );
  }
}
export default SliderWithVideo;